import React, {useEffect, useState} from 'react';
import styles from './CheckboxNew.module.scss';

const CheckboxNew = ({
  isChecked = false,
  handleCheckClick,
  isDisabled = false,
  label = '',
  handleCountrySelect = () => {},
  country,
}) => {
  const [check, setCheck] = useState(isChecked);

  const handleChange = (value) => {
    setCheck(value);
    handleCheckClick?.(isChecked);
    handleCountrySelect(country);
  };

  useEffect(() => {
    setCheck(isChecked);
  }, [isChecked]);

  return isDisabled === true && check ? (
    <div className={styles.outerDiv} onClick={()=>handleChange(check)}>
      <div className={styles.disabledTrueCheckbox}></div> <div>{label}</div>
    </div>
  ) : isDisabled === true ? (
    <div className={styles.outerDiv} onClick={()=>handleChange(check)}>
      <div className={styles.disabledCheckbox}></div> <div>{label}</div>
    </div>
  ) : check ? (
    <div className={styles.outerDiv} onClick={() => handleChange(false)}>
      <div className={styles.selectedCheckbox}></div>
      {label && <div className={styles.lbl}>
        <b>{label}</b>
      </div> }
    </div>
  ) : (
    <div className={styles.outerDiv} onClick={() => handleChange(true)}>
      <div className={styles.unselectedCheckbox}></div>
      {label &&  <div className={styles.lbl}>{label}</div>}
    </div>
  );
};

export default CheckboxNew;
